// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width:1904px){.container[data-v-fe9bd0d2]{max-width:1185px}}.w-page-login[data-v-fe9bd0d2],.w-page-password_reset_confirmation[data-v-fe9bd0d2],.w-page-register[data-v-fe9bd0d2]{max-width:700px}.w-page[data-v-fe9bd0d2]{padding:5em 0}.w-page h2[data-v-fe9bd0d2],.w-page p[data-v-fe9bd0d2]{margin-bottom:.75em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
